import { atom } from "jotai";
import {
  canvasAtom,
  edgesAtom,
  isAiPageAtom,
  nodesAtom,
  streamingProgressAtom,
  zslAtom,
  togglesAtomResettable,
} from "@zapier/canvas-state";
import { isModifyPromptOpenAtom } from "./isModifyPromptOpenAtom";

export const zslToCanvasErrorAtom = atom(null);
zslToCanvasErrorAtom.debugLabel = "zslToCanvasErrorAtom";

export const zslToCanvasPostCommand = atom(
  null,
  async (get, set, zslString: string, isAiPage?: boolean) => {
    const toggles = get(togglesAtomResettable);

    if (toggles.streamingUi && !isAiPage) {
      set(streamingProgressAtom, 0);
      set(isModifyPromptOpenAtom, false);

      const zsl = JSON.parse(zslString);
      // This supports storing the ZSL when we're creating the canvas
      set(zslAtom, zsl); // This needs to go before setting the nodes so that zapAsyncAtomFamily is getting zap data from zsl instead of trying to fetch a zap with fake _ZAP_ id

      const isAiPage = get(isAiPageAtom);

      if (isAiPage && zsl.name) {
        set(canvasAtom, (prevCanvas) => ({
          ...prevCanvas,
          name: zsl.name,
        }));
      }
    } else {
      try {
        const response = await fetch("/api/canvas/v1/canvases/from_zsl/", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: zslString,
        });
        const data = await response.json();

        if (!response.ok) {
          let errorMessage = "An error occurred";
          if (data.detail) {
            errorMessage = data.detail;
          } else if (data.errors) {
            errorMessage = data.errors;
          }
          throw new Error(errorMessage);
        }

        const { nodes, edges } = data.canvas;
        const zsl = JSON.parse(zslString);
        // This supports storing the ZSL when we're creating the canvas
        set(zslAtom, zsl); // This needs to go before setting the nodes so that zapAsyncAtomFamily is getting zap data from zsl instead of trying to fetch a zap with fake _ZAP_ id
        set(nodesAtom, nodes);
        set(edgesAtom, edges);
        set(zslToCanvasErrorAtom, null);

        const isAiPage = get(isAiPageAtom);

        if (isAiPage && zsl.name) {
          set(canvasAtom, (prevCanvas) => ({
            ...prevCanvas,
            name: zsl.name,
          }));
        }

        return { nodes, edges };
      } catch (error: any) {
        set(zslToCanvasErrorAtom, error.message);
      }
    }
  },
);

zslToCanvasPostCommand.debugLabel = "zslToCanvasPostCommand";
